import { BASE_API_URL } from 'src/app/environment';

export interface PublicCheckinInput {
  locationId: string;
  name: string;
  email: string;
  optIn?: boolean;
}

// Fire-and-forget submission optimized for navigation:
// - Uses navigator.sendBeacon with form-encoded body when available
// - Falls back to fetch with keepalive: true without awaiting the response
export function submitPublicCheckin(input: PublicCheckinInput): void {
  const { locationId, name, email, optIn } = input;
  if (!locationId || !name || !email) return;
  const url = `${BASE_API_URL}/locations/${locationId}/checkins`;

  try {
    const params = new URLSearchParams();
    params.set('name', name);
    params.set('email', email);
    if (typeof optIn !== 'undefined') params.set('optIn', String(!!optIn));

    // Prefer sendBeacon with a form-encoded Blob so server urlencoded parser can read it
    if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
      const blob = new Blob([params.toString()], {
        type: 'application/x-www-form-urlencoded;charset=UTF-8',
      });
      navigator.sendBeacon(url, blob);
      return;
    }

    // Fallback: non-blocking fetch with keepalive
    if (typeof fetch !== 'undefined') {
      // Intentionally not awaiting
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: params.toString(),
        keepalive: true,
      }).catch(() => void 0);
    }
  } catch {
    // swallow
  }
}
